/**
 * Session 7 Phase 1 — Operator settings.
 * Minimal: profile view + password change (uses existing in-app
 * password change endpoint). No tenant switch, no Wizard.
 */
import { useState } from "react";
import { api, auth } from "../../lib/api";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";

export default function OperatorSettings() {
  const user = auth.getUser() || {};
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [busy, setBusy] = useState(false);

  const change = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password",
        { old_password: oldPw, new_password: newPw });
      toast.success("Passwort geändert.");
      setOldPw(""); setNewPw("");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error((d && (d.error || d.hint)) || "Konnte Passwort nicht ändern.");
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6" data-testid="operator-settings">
      <header className="space-y-1">
        <h1 className="text-3xl font-semibold tracking-tight">Einstellungen</h1>
        <p className="text-sm text-muted-foreground">
          Operator-Profil und Passwort. Tenant-Einstellungen finden sich pro Tenant.
        </p>
      </header>

      <Card data-testid="operator-profile-card">
        <CardHeader><CardTitle className="text-base">Profil</CardTitle></CardHeader>
        <CardContent className="grid grid-cols-2 gap-2 text-sm">
          <div className="text-muted-foreground">E-Mail</div>
          <div>{user.email}</div>
          <div className="text-muted-foreground">Rolle</div>
          <div>{user.role}</div>
        </CardContent>
      </Card>

      <Card data-testid="operator-password-card">
        <CardHeader><CardTitle className="text-base">Passwort ändern</CardTitle></CardHeader>
        <CardContent>
          <form className="space-y-3 max-w-sm" onSubmit={change}>
            <Input
              type="password"
              placeholder="Aktuelles Passwort"
              value={oldPw}
              onChange={(e) => setOldPw(e.target.value)}
              data-testid="operator-pw-old"
              required
            />
            <Input
              type="password"
              placeholder="Neues Passwort"
              value={newPw}
              onChange={(e) => setNewPw(e.target.value)}
              data-testid="operator-pw-new"
              required
            />
            <Button type="submit" size="sm"
                     disabled={busy || !oldPw || !newPw}
                     data-testid="operator-pw-submit">
              Passwort ändern
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
